<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      session: null
    };
  },
  mounted() {
    if (localStorage.usertoken == null) {
      this.$router.push("/login");
    } else {
      this.session = 1;
    }
  }
};
</script>
